__turbopack_context__.v({
  "logo": "Logo-module-scss-module__yMveqG__logo",
  "logotype": "Logo-module-scss-module__yMveqG__logotype",
  "morningstar": "Logo-module-scss-module__yMveqG__morningstar",
});
